<template>
  <v-flex xs12 class="text-xs-center" v-if="$store.state.users.loadingUsers">
    <v-progress-circular indeterminate :color="$store.state.global.pages[$route.name].color"></v-progress-circular>
  </v-flex>
  <transition name="fadeToggle" mode="out-in" v-else>
    <!-- <v-flex xs12 v-if="listView">
            <v-card hover>
                <v-data-table
                :items="filteredUsers"
                :headers="headers">
                    <template slot="items" slot-scope="props">
                        <table-row :headers="headers" :row="props.item" parent="User" :key="props.item.id">
                        </table-row>
                    </template>
                </v-data-table>
            </v-card>
    </v-flex>-->

    <transition-group name="data-list" tag="layout-no-padding">
      <v-flex
        xs12
        sm6
        md4
        xl3
        v-for="(user,i) in filteredUsers"
        :key="user.id"
        class="data-list-item"
      >
        <user-card :user="user" :index="i"></user-card>
      </v-flex>
    </transition-group>
  </transition>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import UserService from "@/services/requests/userService";
import UserCard from "@/components/users/userCard";
import TableRow from "@/components/ui/masterFileTableRow";
export default {
  data() {
    return {
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        {
          text: "Type",
          align: "left",
          value: "userType.name"
        },
        {
          text: "Tonnage",
          align: "right",
          value: "userType.tonnage"
        },
        {
          text: "Contractor",
          align: "right",
          value: "contractor.name"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false
        }
      ]
    };
  },
  computed: {
    sortBy: Store.getSet({ store: "users", prop: "sortBy" }),
    filterBy: Store.getSet({ store: "users", prop: "filterBy" }),
    users: Store.getSet({ store: "users", prop: "users" }),
    //listView: Store.getSet({store: 'users', prop: 'listView'}),
    sortedUsers() {
      if (this.sortBy) {
        var path = this.sortBy;
        return this.users.sort((a, b) => {
          //if(a[property] < b[property])
          if (this.getObjectPath(path, a) < this.getObjectPath(path, b)) {
            if (path == "updatedAt") {
              return 1;
            }
            return -1;
          } else {
            if (path == "updatedAt") {
              return -1;
            }
            return 1;
          }
        });
      } else {
        return this.users;
      }
    },
    filteredUsers() {
      //return this.users
      return this.sortedUsers.filter(user => {
        return (
          user.name.toLowerCase().indexOf(this.filterBy.toLowerCase()) > -1
        );
      });
    }
  },
  components: {
    UserCard,
    TableRow
  }
};
</script>

<style scoped>
</style>
